import request from "@/utils/request"
// 未代理列表
export const weidaili = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/agent/weidaili",
    });
};

// 已代理列表
export const daili = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/agent/daili",
    });
};
export const quxiao = (params) => {

    return request({
        method: "POST",
        data: {
            company_id:params
        },
        url: "/handle/agent/quxiao_daili",
    });
};
export const company_detail = (params) => {

        return request({
            method: "POST",
            data: {
                company_id:params
            },
            url: "/handle/agent/company_detail",
        });
    };


// WEBPACK FOOTER //
// ./src/api/system/agenciesName.js